import * as React from 'react';
import { Icon, Input } from 'components/antd';
import { InjectedIntlProps, injectIntl } from 'react-intl';

type Props = {
  placeholderId?: string;
  onSearch: (value: string) => void;
  value?: string;
} & InjectedIntlProps;
type State = { value: string };
let userNameInput: Input | null;

class _SearchBar extends React.Component<Props, State> {
  state = {
    value: this.props.value || '',
  };

  emitEmpty = () => {
    if (userNameInput) {
      userNameInput.focus();
      this.setState({ value: '' }, () => this.props.onSearch(''));
    }
  };

  getPlaceholder = () => {
    const { props } = this;
    if (!props.placeholderId) {
      return '';
    }
    return props.intl.formatMessage({
      id: props.placeholderId,
    });
  };

  render() {
    const { state } = this;
    const suffix = state.value ? (
      <Icon
        type="close-circle"
        onClick={this.emitEmpty}
        style={{ cursor: 'pointer' }}
      />
    ) : null;
    return (
      <Input
        placeholder={this.getPlaceholder()}
        value={state.value}
        prefix={<Icon type="search" />}
        suffix={suffix}
        onChange={e => this.setState({ value: e.target.value })}
        onPressEnter={e => this.props.onSearch(state.value)}
        ref={node => (userNameInput = node)}
      />
    );
  }
}
export const SearchBar = injectIntl(_SearchBar);



// WEBPACK FOOTER //
// ./app/components/antd/SearchBar.tsx